
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import DocsLayout from '../../components/DocsLayout'
import Nesting from '../../sections/faqs/nesting.md'
import CSSFrameworks from '../../sections/faqs/support-for-css-frameworks.md'
import OverrideStyles from '../../sections/faqs/override-styles-with-higher-specificity.md'
import OverrideInlineStyles from '../../sections/faqs/override-inline-styles.md'
import TwoDomClasses from '../../sections/faqs/dom-two-classes.md'
import WhenToUseAttrs from '../../sections/faqs/when-to-use-attrs.md'
import LibraryAuthors from '../../sections/faqs/library-authors.md'
import DuplicatedStyledComponents from '../../sections/faqs/duplicated-styled-components.md'
import HTMLAttributeWarnings from '../../sections/faqs/html-attribute-warnings.md'
import BrowserSupport from '../../sections/faqs/browser-support.md'
import MigrationV4 from '../../sections/faqs/migration-v4.md'
import MigrationV5 from '../../sections/faqs/migration-v5.md'
import CRA from '../../sections/faqs/create-react-app.md'
import NPMLink from '../../sections/faqs/npm-link.md'
import FlickeringText from '../../sections/faqs/flickering-text.md'
import DeclareComponentsInRenderMethod from '../../sections/faqs/declare-components-in-render-method.md'
import MissingNativeImport from '../../sections/faqs/missing-native-import.md'


const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
<DocsLayout title="FAQs" description="Commonly asked questions about styled-components">
{children}
</DocsLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <MigrationV5 mdxType="MigrationV5" />
    <MigrationV4 mdxType="MigrationV4" />
    <Nesting mdxType="Nesting" />
    <CSSFrameworks mdxType="CSSFrameworks" />
    <OverrideStyles mdxType="OverrideStyles" />
    <OverrideInlineStyles mdxType="OverrideInlineStyles" />
    <TwoDomClasses mdxType="TwoDomClasses" />
    <WhenToUseAttrs mdxType="WhenToUseAttrs" />
    <LibraryAuthors mdxType="LibraryAuthors" />
    <DuplicatedStyledComponents mdxType="DuplicatedStyledComponents" />
    <DeclareComponentsInRenderMethod mdxType="DeclareComponentsInRenderMethod" />
    <HTMLAttributeWarnings mdxType="HTMLAttributeWarnings" />
    <BrowserSupport mdxType="BrowserSupport" />
    <CRA mdxType="CRA" />
    <NPMLink mdxType="NPMLink" />
    <FlickeringText mdxType="FlickeringText" />
    <MissingNativeImport mdxType="MissingNativeImport" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;